import { useListTransactions } from '@/generated/hooks';
import type {
	ListTransactionsQueryType,
	ListTransactionsParamsType,
} from '@zlinkx/shared-v2';

interface UseMerchantTransactionsOptions {
	merchantId: ListTransactionsParamsType['merchantId'];
	query?: ListTransactionsQueryType;
	enabled?: boolean;
}

export function useMerchantTransactions({
	merchantId,
	query,
	enabled = true,
}: UseMerchantTransactionsOptions) {
	return useListTransactions(
		{
			merchantId,
			query,
		},
		{
			enabled: Boolean(merchantId) && enabled,
		},
	);
}

export default useMerchantTransactions;
